import type { ReactNode } from 'react'
import { cx } from '@/utils/cx'

/**
 * Reiter, wie sie die Kundendetails der Kundenverwaltung tragen: eine Zeile
 * mit Unterstrich in der Markenfarbe am aktiven Register. Dieselbe Bauform in
 * beiden Oberflächen — wer beide sieht, soll sie als eine erkennen.
 *
 * Kein Zustand hier: Welches Register gilt, sagt die Seite; sie behält damit
 * auch alles, was über den Reitern steht (Filter, Zeitraum), für alle Register.
 */
export function Reiterleiste({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cx('flex gap-5 border-b border-secondary', className)} role="tablist">
      {children}
    </div>
  )
}

export function Reiter({
  children,
  an,
  onWahl,
  anzahl,
}: {
  children: string
  an: boolean
  onWahl: () => void
  /** Kleine Zahl neben dem Namen — etwa wie viele Zeilen das Register hat. */
  anzahl?: number
}) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={an}
      onClick={onWahl}
      className={cx(
        '-mb-px flex cursor-pointer items-center gap-1.5 border-b-2 py-[9px] text-[13.5px] transition-colors',
        an
          ? 'border-akzent font-semibold text-primary'
          : 'border-transparent text-tertiary hover:text-primary',
      )}
    >
      {children}
      {anzahl !== undefined ? (
        <span className="rounded-full bg-secondary px-1.5 text-[11px] font-medium text-tertiary tabular-nums">
          {anzahl}
        </span>
      ) : null}
    </button>
  )
}
